module.exports = __webpack_public_path__ + "img/dead_aragog.d95a19a6.jpg";